/* eslint-disable no-use-before-define */
import React from 'react'
import { arrayToggle, isEmpty } from '../../../twd/twd'
import useScatterGraph from '../use-scatter-graph';
import CircleLabel from './circle-label'

export default () => {
    const {colors,
        top5Tickers, selectedTop5Tickers, setSelectedTop5Tickers,
        customTickers, selectedCustomTickers, setSelectedCustomTickers
    } = useScatterGraph()

    let isTop5 = isEmpty(customTickers)
    let items = isTop5 ? top5Tickers : customTickers
    let selected = isTop5 ? selectedTop5Tickers : selectedCustomTickers
    let setSelected = isTop5 ? setSelectedTop5Tickers : setSelectedCustomTickers

    return <React.Fragment>
    {
        items
        .map((a,i) => {
            return {
                label: a,
                color: colors[5+i],
                selected: selected.indexOf(a)>=0
            }
        })
        .filter(a => a.selected)
        .map((a,i)=> (
            <button
                data-name="corporates-scatter-graph-tag"
                data-label={a.label}
                key={i}
                className="tag tag-dismissible"
                style={{
                    margin: '1px',
                }}
                onClick={() => {
                    let n = arrayToggle(selected, a.label)
                    setSelected([...n])
                }}
            ><CircleLabel color={a.color} label={a.label} />
            </button>
        ))
    }
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/criteria/tags.js